import { Card, CardContent, Stack, TextField, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FormField, IFormStore } from '@tom-ui/utils'
import { PierResponse } from '@yard/app/api'
import { observer } from 'mobx-react-lite'
import { PierFormData } from '../../models/pier.model'

interface Props {
  formStore: IFormStore<PierFormData>
  pier: PierResponse | undefined
}

export const PierForm = observer(({ formStore, pier }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <Card>
      <CardContent>
        <Stack component='form' noValidate autoComplete='off' gap={theme.customSpacing.l}>
          <Stack flexDirection='row' justifyContent='space-between' alignItems='center'>
            <Typography variant='subtitle1'>{t('pierDetails', 'Pier details')}</Typography>
          </Stack>

          <FormField
            formStore={formStore}
            name={'name'}
            initialValue={pier?.name ?? ''}
            validate={value => {
              if (!value) return t('fieldIsRequired', 'Field is required')
            }}
          >
            {store => (
              <Stack gap={theme.customSpacing.s}>
                <TextField
                  {...store.props}
                  fullWidth
                  label={`${t('name', 'Name')}`}
                  required
                  name='name'
                />
                <Typography variant='caption' color={store.error ? 'error' : 'text.secondary'}>
                  {store.error ||
                    t('pleaseMakeSureItsAUniqueField', "Please make sure it's a unique {field}", {
                      field: t('name', 'name'),
                    })}
                </Typography>
              </Stack>
            )}
          </FormField>
        </Stack>
      </CardContent>
    </Card>
  )
})
